const PROGRESS_BAR_MAX_VALUE = 100;

export const getProgressBarValue = (value: number, max: number): number => {
  return (value * PROGRESS_BAR_MAX_VALUE) / max;
};
